import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Box, Grid, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { StandardLoadingButton } from "../../../../../../../shared/components/buttons/LoadingButton"
import { useDateTime } from "../../../../../../localization/useDateTime"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { ActionType } from "./MeetingCardMenu"

const useStyles = makeStyles()(() => ({
    confirmModalContainer: {
        padding: "0 2rem 3rem 2rem",
    },
}))

export type ActionConfirmationDialogMeeting = Readonly<{
    id: number
    meetingDetails: {
        meetingName: string
        startDateTime: string
    }
    deliveryDetails?: {
        time: string
    }
}>

type ActionConfirmationDialogProps = {
    open: boolean
    onClose: () => void
    onConfirm: () => void
    actionType: ActionType
    meeting: ActionConfirmationDialogMeeting
    isLoading?: boolean
}

export function ActionConfirmationDialog({
    open,
    onClose,
    onConfirm,
    actionType,
    meeting,
    isLoading = false,
}: ActionConfirmationDialogProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const dateTimeFactory = useDateTime()

    const getActionTitle = () => {
        switch (actionType) {
            case "edit_meeting":
                return l10n.getString("user-home-meeting-service-action-edit")
            case "duplicate_meeting_service":
                return l10n.getString("user-home-meeting-service-action-duplicate-meeting-service")
        }
    }

    const getActionDescription = () => {
        switch (actionType) {
            case "edit_meeting":
                // && meeting?.orderSummary.hasCatering in case we'll have in future every order with orderSummary
                if (meeting?.deliveryDetails) {
                    return l10n.getString("user-home-meeting-service-description-update-meeting-service-catering", {
                        meetingName: meeting?.meetingDetails?.meetingName,
                        orderId: meeting?.id.toString(),
                        deliveryDate: dateTimeFactory.formatDateTime(
                            dateTimeFactory.fromApi(meeting?.deliveryDetails?.time),
                        ),
                    })
                }
                return l10n.getString("user-home-meeting-service-description-update-meeting-service", {
                    meetingName: meeting?.meetingDetails?.meetingName,
                    orderId: meeting?.id.toString(),
                    deliveryDate: dateTimeFactory.formatDate(
                        dateTimeFactory.fromApi(meeting?.meetingDetails?.startDateTime),
                    ),
                })
            case "duplicate_meeting_service":
                return l10n.getString("user-home-meeting-service-description-duplicate-meeting-service", {
                    meetingName: meeting?.meetingDetails?.meetingName,
                    orderId: meeting?.id.toString(),
                    deliveryDate: meeting?.deliveryDetails
                        ? dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(meeting?.deliveryDetails?.time))
                        : "",
                })
        }
    }

    const handleConfirm = async () => {
        await onConfirm()
    }

    return (
        <StandardDialog open={open} onClose={onClose} maxWidthProp="sm" dialogTitle={getActionTitle()}>
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                wrap="nowrap"
                className={classes.confirmModalContainer}
            >
                <Stack spacing={4} alignItems="center" width="100%">
                    <Typography variant="body1" align="center">
                        {getActionDescription()}
                    </Typography>
                    <Box display="flex" gap={2}>
                        <LocalizedStrict id="user-home-canteen-upcoming-orders-end-modal-confirm">
                            <StandardLoadingButton onClick={handleConfirm} loading={isLoading}>
                                Confirm
                            </StandardLoadingButton>
                        </LocalizedStrict>
                    </Box>
                </Stack>
            </Grid>
        </StandardDialog>
    )
}
